import Filters from "../../utils/_livesearch";

Filters.init("webinars");
